import React from 'react';
import { Link } from 'react-router-dom';
import DocxiLogo from '../../../assets/logo.png';

const SidebarComponent = ({ collapsed }) => (
  <h1 className="pointer mb-0 text-white" style={{ height: 60, background: '#C8F1FD' }}>
    <Link className="flex justify-center items-center w-full h-full text-white" to="/">
      <img
        src={DocxiLogo}
        alt="DOCXI"
        style={{ paddingTop: 74, width: 'auto', objectFit: 'contain', filter: 'brightness(1.1)' }}
      />
    </Link>
  </h1>
);

export default SidebarComponent;
